import React, {Component} from "react";
import {WindowParam, WindowParamContext} from "../../library/context/WindowContext";
import {ColumnUnit} from "../../library/atomic/unit/ColumnUnit";
import {FontAttr} from "../../library/basic/font";
import {TopNav} from "./components/TopNav";
import {BoxUnit, heightGap, widthGap} from "../../library/atomic/unit/BoxUnit";
import {SizeAttr} from "../../library/basic/size";
import {ImageUnit} from "../../library/atomic/image/ImageUnit";
import officeHomeColorBg from "../../assets/official/office-home-color-bg.svg"
import knowMoreIcon from "../../assets/official/office-home-know-more-icon.svg";
import HomeInfoBox, {HomeInfoButton} from "./components/HomeInfoBox";
import {getOfficialInnerSectionWidth, getTopNavHeight, isSizeRangePhone} from "./compose/sizeRange";
import "./HomePage.css"
import {RowUnit} from "../../library/atomic/unit/RowUnit";
import {BoxAttr, ColumnAttr, RowAttr} from "../../library/basic/compose";
import {SpanText} from "../../library/atomic/text/SpanText";
import {DownloadBox} from "./components/DownloadBox";
import {BrowserOpenHint} from "./components/InnerTop";
import BottomFooter from "./components/BottomFooter";

const officeHomePcBg = "https://coralplanets.oss-cn-shanghai.aliyuncs.com/static/official/office-home-pc-coral-bg.svg"
const officeHomePhoneBg = "https://coralplanets.oss-cn-shanghai.aliyuncs.com/static/official/office-home-phone-coral-bg.svg"

const baseOssImgPhoneUrl = "https://coralplanets.oss-cn-shanghai.aliyuncs.com/static/official/phone"
const socialPhone = baseOssImgPhoneUrl + "/social-phone.svg";
const socialPhonePad = baseOssImgPhoneUrl + "/social-phone-pad.svg";
const socialMsg = baseOssImgPhoneUrl + "/social-msg.svg"
const socialMsgPhone = baseOssImgPhoneUrl + "/social-phone-phone.png"
const activityPhone = baseOssImgPhoneUrl + "/activity-phone.svg";
const activityPhonePad = baseOssImgPhoneUrl + "/activity-phone-pad.svg";
const activityPhonePhone = baseOssImgPhoneUrl + "/activity-phone-phone.png";
const aiPhone = baseOssImgPhoneUrl + "/ai-phone.svg";
const aiPhonePad = baseOssImgPhoneUrl + "/ai-phone-pad.svg";
const aiPhonePhone = baseOssImgPhoneUrl + "/ai-phone-phone.png";

export class HomePage extends Component {
    static contextType = WindowParamContext;

    state: {
        showBrowserHint: boolean
    } = {
        showBrowserHint: false
    }

    render() {
        return (
            <WindowParamContext.Consumer>
                {wpt => {
                    let wp = wpt.param;
                    let topNavHeight = SizeAttr.getPxNumber(getTopNavHeight(wp))
                    let sectionHeightNum = wp.currHeight - topNavHeight >= 540 ? wp.currHeight - topNavHeight : 540
                    let sectionHeightNumPx = sectionHeightNum + "px"

                    // 文字
                    let titleFontSize = "34px"
                    let contentFontSize = "24px"
                    let contentLeftMargin = "32px"

                    // 信息面板布局
                    let innerSectionWidth = getOfficialInnerSectionWidth(wp)
                    let sectionFlexCus: any = {"flexDirection": "row"}
                    let imgSectionWidth = SizeAttr.pxMultiple(innerSectionWidth, 0.5)
                    let textSectionWidth = imgSectionWidth
                    let textSectionColCus = {}
                    let actSectionColCus: any = {"marginRight": "auto"}

                    // pad宽度区间缩减图片宽度
                    let useSmallPicRow = wp.currWidth <= 1200 && wp.currWidth >= 875
                    if (useSmallPicRow) {
                        imgSectionWidth = SizeAttr.pxMultiple(innerSectionWidth, 0.28)
                        textSectionWidth = SizeAttr.pxMultiple(innerSectionWidth, 0.72)
                        textSectionColCus = {"marginLeft": "auto"}
                        actSectionColCus = {"marginLeft": "96px", "marginRight": "auto"}
                    }

                    // 宽度小于875时采用纵向布局
                    let useColDisplay = wp.currWidth < 875
                    if (useColDisplay) {
                        imgSectionWidth = innerSectionWidth
                        textSectionWidth = innerSectionWidth
                        sectionFlexCus = {"flexDirection": "column", "marginTop": "96px", "marginBottom": "0px"}
                        sectionHeightNumPx = ""
                        textSectionColCus = Object.assign(ColumnAttr.getChildrenPositionObj(), {
                            "marginBottom": "64px"
                        })
                        actSectionColCus = textSectionColCus
                    }

                    if (isSizeRangePhone(wp)) {
                        titleFontSize = "28px"
                        contentFontSize = "18px"
                        contentLeftMargin = "10px"
                        textSectionColCus = ColumnAttr.getChildrenPositionObj()
                        actSectionColCus = textSectionColCus
                    }
                    if (wp.currWidth <= 420) {
                        titleFontSize = "22px"
                    }

                    // 落地面板
                    let landingSection = () => {
                        return (
                            <BoxUnit
                                classname={"landing-section"}
                                sizeAttr={new SizeAttr(wp, "100vw", sectionHeightNum + "px")}
                                customStyleAttr={{
                                    "position": "relative"
                            }}>
                                {HomeInfoBox(wp, {
                                    "position": "absolute",
                                    "zIndex": "1000",
                                    "transform": "translateY(" + (sectionHeightNum / (isSizeRangePhone(wp) ? (wp.currHeight > 680 ? 3 : 4) : 2.5)) + "px)"
                                }, () => {
                                    window.scrollTo({
                                        top: wp.currHeight - SizeAttr.getPxNumber(getTopNavHeight(wp)),
                                        behavior: "smooth"
                                    })
                                }, () => {
                                    this.setState(prevState => (Object.assign(prevState,
                                        {
                                            "showBrowserHint": true
                                        })))
                                })}
                            </BoxUnit>
                        )
                    }

                    // 社区内容
                    let societySection = () => {
                        return (
                            <BoxUnit
                                sizeAttr={new SizeAttr(wp, "100vw", sectionHeightNumPx)}>
                                <RowUnit
                                    sizeAttr={new SizeAttr(wp, getOfficialInnerSectionWidth(wp))}
                                    customStyleAttr={Object.assign(BoxAttr.getChildrenPositionObj(), sectionFlexCus)}>
                                    {
                                        !useColDisplay &&
                                        <RowUnit
                                            sizeAttr={new SizeAttr(wp, imgSectionWidth)}
                                            customStyleAttr={RowAttr.getChildrenPositionObj()}>
                                            <ImageUnit
                                                customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(), {
                                                    "marginRight": "auto"
                                                })}
                                                sizeAttr={new SizeAttr(wp, "", "520px")}
                                                url={!useSmallPicRow ? socialPhone : socialPhonePad}/>
                                        </RowUnit>
                                    }
                                    <ColumnUnit
                                        sizeAttr={new SizeAttr(wp, textSectionWidth)}
                                        fontAttr={new FontAttr(wp, "", "", "\"SongTi SC\"")}
                                        customStyleAttr={useColDisplay ? ColumnAttr.getChildrenPositionObj() : RowAttr.getChildrenPositionObj()}>
                                        <ColumnUnit customStyleAttr={textSectionColCus}>
                                            <ColumnUnit
                                                customStyleAttr={useColDisplay ? ColumnAttr.getChildrenPositionObj() : {}}>
                                                <SpanText
                                                    customStyleAttr={{"justifyContent": ""}}
                                                    fontAttr={new FontAttr(wp, titleFontSize, "600")}
                                                >
                                                    {"精彩内容、实时信息轻松查看"}
                                                </SpanText>
                                                <SpanText
                                                    customStyleAttr={{
                                                        "justifyContent": "",
                                                        "marginLeft": contentLeftMargin,
                                                        "marginTop": "18px"
                                                    }}
                                                    fontAttr={new FontAttr(wp, contentFontSize, "600")}
                                                >
                                                    {"·快速浏览社团资讯、校园日常"}
                                                </SpanText>
                                                <SpanText
                                                    customStyleAttr={{
                                                        "justifyContent": "",
                                                        "marginLeft": contentLeftMargin,
                                                        "marginTop": "9.5px"
                                                    }}
                                                    fontAttr={new FontAttr(wp, contentFontSize, "600")}
                                                >
                                                    {"·向各校同学轻松提问、发起讨论"}
                                                </SpanText>
                                            </ColumnUnit>
                                            {
                                                !isSizeRangePhone(wp) &&
                                                <ImageUnit
                                                    customStyleAttr={{
                                                        "marginTop": "66px"
                                                    }}
                                                    sizeAttr={new SizeAttr(wp, SizeAttr.pxMultiple(textSectionWidth, 0.88))}
                                                    url={socialMsg}/>
                                            }
                                        </ColumnUnit>
                                    </ColumnUnit>

                                    {
                                        useColDisplay && !isSizeRangePhone(wp) &&
                                        <RowUnit
                                            sizeAttr={new SizeAttr(wp, imgSectionWidth)}
                                            customStyleAttr={Object.assign(ColumnAttr.getChildrenPositionObj(), {
                                                "marginTop": "64px",
                                                "marginBottom": "64px"
                                            })}>
                                            <ImageUnit
                                                customStyleAttr={ColumnAttr.getChildrenPositionObj()}
                                                sizeAttr={new SizeAttr(wp, "", "480px")}
                                                url={socialPhone}/>
                                        </RowUnit>
                                    }

                                    {
                                        useColDisplay && isSizeRangePhone(wp) &&
                                        PhonePicCard(wp, socialMsgPhone, imgSectionWidth)
                                    }

                                </RowUnit>
                            </BoxUnit>
                        )
                    }

                    // 活动内容
                    let activitySection = () => {
                        return (
                            <BoxUnit
                                sizeAttr={new SizeAttr(wp, "100vw", sectionHeightNumPx)}>
                                <RowUnit
                                    sizeAttr={new SizeAttr(wp, getOfficialInnerSectionWidth(wp))}
                                    customStyleAttr={Object.assign(BoxAttr.getChildrenPositionObj(), sectionFlexCus)}>
                                    <ColumnUnit
                                        sizeAttr={new SizeAttr(wp, textSectionWidth)}
                                        fontAttr={new FontAttr(wp, "", "", "\"SongTi SC\"")}
                                        customStyleAttr={useColDisplay ? ColumnAttr.getChildrenPositionObj() : RowAttr.getChildrenPositionObj()}>
                                        <ColumnUnit customStyleAttr={actSectionColCus}>
                                            <ColumnUnit
                                                customStyleAttr={useColDisplay ? ColumnAttr.getChildrenPositionObj() : {}}>
                                                <SpanText
                                                    customStyleAttr={{"justifyContent": ""}}
                                                    fontAttr={new FontAttr(wp, titleFontSize, "600")}
                                                >
                                                    {"各校活动一键报名"}
                                                </SpanText>
                                                <SpanText
                                                    customStyleAttr={{
                                                        "justifyContent": "",
                                                        "marginLeft": contentLeftMargin,
                                                        "marginTop": "18px"
                                                    }}
                                                    fontAttr={new FontAttr(wp, contentFontSize, "600")}
                                                >
                                                    {"# 第十六届“木头说”音乐会"}
                                                </SpanText>
                                                <SpanText
                                                    customStyleAttr={{
                                                        "justifyContent": "",
                                                        "marginLeft": contentLeftMargin,
                                                        "marginTop": "9.5px"
                                                    }}
                                                    fontAttr={new FontAttr(wp, contentFontSize, "600")}
                                                >
                                                    {"# 书画春天的园艺师"}
                                                </SpanText>
                                                <SpanText
                                                    customStyleAttr={{
                                                        "justifyContent": "",
                                                        "marginLeft": contentLeftMargin,
                                                        "marginTop": "9.5px"
                                                    }}
                                                    fontAttr={new FontAttr(wp, contentFontSize, "600")}
                                                >
                                                    {"# 魔幻现实主义书籍交流分享会"}
                                                </SpanText>
                                            </ColumnUnit>
                                        </ColumnUnit>
                                    </ColumnUnit>

                                    {
                                        !useColDisplay &&
                                        <RowUnit
                                            sizeAttr={new SizeAttr(wp, imgSectionWidth)}
                                            customStyleAttr={RowAttr.getChildrenPositionObj()}>
                                            <ImageUnit
                                                customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(), {
                                                    "marginLeft": "auto",
                                                    "marginRight": useSmallPicRow ? "48px" : ""
                                                })}
                                                sizeAttr={new SizeAttr(wp, "", "520px")}
                                                url={!useSmallPicRow ? activityPhone : activityPhonePad}/>
                                        </RowUnit>
                                    }

                                    {
                                        useColDisplay && !isSizeRangePhone(wp) &&
                                        <RowUnit
                                            sizeAttr={new SizeAttr(wp, imgSectionWidth)}
                                            customStyleAttr={Object.assign(ColumnAttr.getChildrenPositionObj(), {
                                                "marginTop": "64px",
                                                "marginBottom": "64px"
                                            })}>
                                            <ImageUnit
                                                customStyleAttr={ColumnAttr.getChildrenPositionObj()}
                                                sizeAttr={new SizeAttr(wp, "", "480px")}
                                                url={activityPhone}/>
                                        </RowUnit>
                                    }

                                    {
                                        useColDisplay && isSizeRangePhone(wp) &&
                                        PhonePicCard(wp, activityPhonePhone, imgSectionWidth)
                                    }
                                </RowUnit>
                            </BoxUnit>
                        )
                    }

                    // AI学习帮手
                    let aiSection = () => {
                        return (
                            <BoxUnit
                                sizeAttr={new SizeAttr(wp, "100vw", sectionHeightNumPx)}>
                                <RowUnit
                                    sizeAttr={new SizeAttr(wp, getOfficialInnerSectionWidth(wp))}
                                    customStyleAttr={Object.assign(BoxAttr.getChildrenPositionObj(), sectionFlexCus)}>
                                    {
                                        !useColDisplay &&
                                        <RowUnit
                                            sizeAttr={new SizeAttr(wp, SizeAttr.pxPlus(imgSectionWidth, "48px"))}
                                            customStyleAttr={RowAttr.getChildrenPositionObj()}>
                                            <ImageUnit
                                                customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(), {
                                                    "marginRight": "auto",
                                                    "marginLeft": useSmallPicRow ? "48px" : ""
                                                })}
                                                sizeAttr={new SizeAttr(wp, "", useSmallPicRow ? "520px" : "488px")}
                                                url={!useSmallPicRow ? aiPhone : aiPhonePad}/>
                                        </RowUnit>
                                    }
                                    <ColumnUnit
                                        sizeAttr={new SizeAttr(wp, SizeAttr.pxMinus(textSectionWidth, "48px"))}
                                        fontAttr={new FontAttr(wp, "", "", "\"SongTi SC\"")}
                                        customStyleAttr={useColDisplay ? ColumnAttr.getChildrenPositionObj() : RowAttr.getChildrenPositionObj()}>
                                        <ColumnUnit customStyleAttr={textSectionColCus}>
                                            <ColumnUnit
                                                customStyleAttr={useColDisplay ? ColumnAttr.getChildrenPositionObj() : {}}>
                                                <SpanText
                                                    customStyleAttr={{"justifyContent": ""}}
                                                    fontAttr={new FontAttr(wp, titleFontSize, "600")}
                                                >
                                                    {"你的学习帮手——珊瑚同学AI"}
                                                </SpanText>
                                                <SpanText
                                                    customStyleAttr={{
                                                        "justifyContent": "",
                                                        "marginLeft": contentLeftMargin,
                                                        "marginTop": "18px"
                                                    }}
                                                    fontAttr={new FontAttr(wp, contentFontSize, "600")}
                                                >
                                                    {"·提问大类专业的整体规划"}
                                                </SpanText>
                                                <SpanText
                                                    customStyleAttr={{
                                                        "justifyContent": "",
                                                        "marginLeft": contentLeftMargin,
                                                        "marginTop": "9.5px"
                                                    }}
                                                    fontAttr={new FontAttr(wp, contentFontSize, "600")}
                                                >
                                                    {"·咨询细分方向的学习路径"}
                                                </SpanText>
                                                <SpanText
                                                    customStyleAttr={{
                                                        "justifyContent": "",
                                                        "marginLeft": contentLeftMargin,
                                                        "marginTop": "9.5px"
                                                    }}
                                                    fontAttr={new FontAttr(wp, contentFontSize, "600")}
                                                >
                                                    {"·推荐相关学习资料和经验"}
                                                </SpanText>
                                                <SpanText
                                                    customStyleAttr={{
                                                        "justifyContent": "",
                                                        "marginLeft": contentLeftMargin,
                                                        "marginTop": "9.5px",
                                                        "marginBottom": wp.currWidth >= 535 ? "48px" : ""
                                                    }}
                                                    fontAttr={new FontAttr(wp, contentFontSize, "600")}
                                                >
                                                    {"·总结求职经验和岗位要求"}
                                                </SpanText>
                                                {
                                                    wp.currWidth >= 535 &&
                                                    <RowUnit customStyleAttr={{"marginLeft": contentLeftMargin}}>
                                                        {HomeInfoButton(wp, knowMoreIcon, "访问【珊瑚同学】网页版", () => {

                                                        }, "300px", "#0EE3CA7C")}
                                                    </RowUnit>
                                                }
                                                {!useColDisplay && widthGap(wp, SizeAttr.pxMultiple(textSectionWidth, 0.78))}
                                            </ColumnUnit>
                                        </ColumnUnit>
                                    </ColumnUnit>

                                    {
                                        useColDisplay && !isSizeRangePhone(wp) &&
                                        <RowUnit
                                            sizeAttr={new SizeAttr(wp, imgSectionWidth)}
                                            customStyleAttr={Object.assign(ColumnAttr.getChildrenPositionObj(), {
                                                "marginTop": "64px",
                                                "marginBottom": "64px"
                                            })}>
                                            <ImageUnit
                                                customStyleAttr={ColumnAttr.getChildrenPositionObj()}
                                                sizeAttr={new SizeAttr(wp, "", "480px")}
                                                url={aiPhone}/>
                                        </RowUnit>
                                    }

                                    {
                                        useColDisplay && isSizeRangePhone(wp) &&
                                        PhonePicCard(wp, aiPhonePhone, imgSectionWidth)
                                    }
                                </RowUnit>
                            </BoxUnit>
                        )
                    }

                    // TODO: 横向布局时采用离散滚动切换
                    return (
                        <ColumnUnit fontAttr={new FontAttr(wp, "", "", "\"PingFang SC\"")}>
                            {this.state.showBrowserHint && BrowserOpenHint(wp, () => {
                                this.setState(prevState => (Object.assign(prevState,
                                    {
                                        "showBrowserHint": false
                                    })))
                            })}
                            <TopNav showBrowserHint={() => {
                                this.setState(prevState => (Object.assign(prevState,
                                    {
                                        "showBrowserHint": true
                                    })))
                            }}/>
                            {heightGap(wp, getTopNavHeight(wp))}
                            {landingSection()}
                            {/*{societySection()}*/}
                            {/*{activitySection()}*/}
                            {/*{aiSection()}*/}
                            {useColDisplay && heightGap(wp, isSizeRangePhone(wp) ? "16px" : "96px")}
                            {DownloadBox(wp)}
                            {BottomFooter(wp)}
                        </ColumnUnit>
                    )
                }
                }
            </WindowParamContext.Consumer>
        )
    }
}

function PhonePicCard(wp: WindowParam, pic: string, imgSectionWidth: string) {
    let innerCardWidth = SizeAttr.pxMultiple(imgSectionWidth, 0.94)
    let picWidth = SizeAttr.pxMinus(innerCardWidth, "6px")

    return (
        <ColumnUnit
            sizeAttr={new SizeAttr(wp, innerCardWidth)}
            customStyleAttr={Object.assign(ColumnAttr.getChildrenPositionObj(), {
                "marginTop": "64px",
                "marginBottom": "0px",
                "borderRadius": "10px",
                "border": "2px solid rgba(0, 0, 0, 0.1)",
                "boxShadow": "0 0 5.2px rgba(0, 0, 0, 0.12), 0 5.2px 10.4px rgba(0, 0, 0, 0.14)"
            })}>
            <ImageUnit
                customStyleAttr={Object.assign(ColumnAttr.getChildrenPositionObj(), {
                    "marginTop": "3px",
                    "marginBottom": "3px"
                })}
                innerImgStyle={{
                    "borderRadius": "10px"
                }}
                sizeAttr={new SizeAttr(wp, picWidth)}
                url={pic}/>
        </ColumnUnit>
    )
}